import * as React from 'react';

import CreatorOnBoardingContainer from './creatorOnBoardingContainer';

export default function CreatorOnBoarding() {
  return <CreatorOnBoardingContainer />;
}
